// ─── Padrão único de filename pra download de fatura ─────────────────
// Princípio Douglas (24/05): "para não gerar nunca mais como bee".
// Todo lugar no front que baixa PDF de fatura DEVE usar este utilitário.
// Replica a mesma regra da edge function enviar-fatura-pdf-cliente, garantindo
// que o nome do arquivo no celular do cliente bate com o nome do arquivo
// que o operador baixa.

export type FaturaFilenameMeta = {
  razao_social?: string | null;
  nome_fantasia?: string | null;
  cnpj?: string | null;
  // Preferimos periodo_fim (data de vencimento) pra montar o "VENC_Mês-Ano";
  // se não houver, usa created_at como aproximação razoável.
  periodo_fim?: string | null;
  created_at?: string | null;
};

const MESES = [
  'Janeiro', 'Fevereiro', 'Marco', 'Abril', 'Maio', 'Junho',
  'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro',
];

function sanitize(s: string | null | undefined): string {
  return (s || '')
    .normalize('NFD')
    .replace(/[̀-ͯ]/g, '')
    .replace(/[^a-zA-Z0-9_-]+/g, '_')
    .replace(/_+/g, '_')
    .replace(/^_|_$/g, '')
    .slice(0, 40) || 'fatura';
}

/**
 * Monta filename descritivo no formato:
 *   RAZAO_CNPJ_VENC_Mes-Ano.pdf
 * Exemplo: EMPRESARIAL_PRIME_20496122000128_VENC_Abril-2026.pdf
 *
 * Se faltar metadata, gera o melhor possível com o que tem.
 */
export function buildFaturaFilename(meta: FaturaFilenameMeta): string {
  const razaoSlug = sanitize(meta.razao_social || meta.nome_fantasia || 'cliente');
  const cnpjSlug = (meta.cnpj || '').replace(/\D/g, '');

  const iso = String(meta.periodo_fim || meta.created_at || '').match(/^(\d{4})-(\d{2})/);
  const hoje = new Date();
  const ano = iso ? Number(iso[1]) : hoje.getFullYear();
  const mes = iso ? Number(iso[2]) - 1 : hoje.getMonth();

  const mesSlug = `${MESES[mes]}-${ano}`;

  return cnpjSlug
    ? `${razaoSlug}_${cnpjSlug}_VENC_${mesSlug}.pdf`
    : `${razaoSlug}_VENC_${mesSlug}.pdf`;
}
